<template>
	<div class="">
		<div class="title">
			{{$t('index.welcome')}}
		</div>
		<!-- <el-row :gutter="20" class="xiala">
			<el-col :span="24">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>站点信息</span>
					</div>
					<div class="zhijigaid">
	                    <p>最后登陆时间：<span>2020-12-15 09:56:18</span> </p>
	                    <p>最后登陆IP： <span>113.235.125.8</span> </p>
	                    <p>程序语言版本：<span>7.3.21</span> </p>
	                    <p>数据库版本：<span>5.7.28-log</span> </p>
	                    <p>系统最大附件：<span>50M</span> </p>
	                    <p>站点最大附件：<span>10MB</span> </p>
	                    <p>附件类型：<span>jpg,gif,jpeg,png</span> </p>
					</div>
				</el-card>
			</el-col>
		</el-row> -->
	</div>
</template>

<script>
	export default {
		data(){
			return {
				value1:'',
				value2:'',
				activity: [],
				data_data: [],
				user_data:[],
				detection_data:[],
				order_data:[],
			}
		}
	}

</script>

<style scoped>
.title {
	font-size: 20px;
	padding: 20px;
	line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue